import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 300, // not sure how to make it so corners are rounded but not whole thing
  },
  // Sizes
  xs: {
    height: 32,
    padding: "4px 8px",
  },
  sm: {
    height: 32,
    padding: "4px 12px",
  },
  md: {
    height: 40,
    padding: "8px 16px",
  },
  lg: {
    height: 48,
    padding: "12px 16px",
  },
  xl: {
    height: 56,
    padding: "16px 24px",
  },
  // Variants
  tertiary: {
    backgroundColor: theme.palette.inverse.bkg.primary,
    color: theme.palette.inverse.content.primary,
    "&:hover": {
      boxShadow: "inset 999px 999px 0px rgba(255, 255, 255, 0.16) !important",
      backgroundColor: theme.palette.inverse.bkg.primary,
    },
  },
  outlined: {
    color: theme.palette.content.primary,
    border: "1px solid #666666",
    backgroundColor: "transparent",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.08)", // TODO: fix this, this is just a darker black
      color: theme.palette.content.primary,
      border: "1px solid #666666",
    },
  },
  text: {
    backgroundColor: "transparent",
    color: theme.palette.content.primary,
    "&:hover": {
      background: "rgba(0, 0, 0, 0.06)",
      color: theme.palette.content.primary,
    },
  },
}));
